module.exports = __webpack_public_path__ + "media/images/metronic/social/facebook-9cc731bedb8a04316481b2870d9ef495.png";